var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activity-form" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.isEdit ? "编辑活动" : "添加活动",
          backUrl: "/market/activity/list",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              model: {
                value: _vm.currentStep,
                callback: function ($$v) {
                  _vm.currentStep = $$v
                },
                expression: "currentStep",
              },
            },
            _vm._l(_vm.stepTabs, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { label: item.title, name: item.name },
              })
            }),
            1
          ),
          _c("div", { staticClass: "form-tips" }, [
            _c("i", { staticClass: "el-icon-info" }),
            _c("span", [
              _vm._v("请按照步骤填写活动信息，带 "),
              _c("span", { staticClass: "required-mark" }, [_vm._v("*")]),
              _vm._v(" 的字段为必填项，建议上传高质量图片以提升活动展示效果"),
            ]),
          ]),
          _c(
            "el-form",
            {
              ref: "activityForm",
              staticClass: "activity-form-content",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "0",
                      expression: "currentStep === '0'",
                    },
                  ],
                  staticClass: "step-content",
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "marketId" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 关联集市： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "请选择要举办活动的集市，系统将自动关联该集市的商户信息",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "280px" },
                          attrs: {
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            placeholder: "请选择或搜索集市",
                            "remote-method": _vm.searchMarkets,
                            loading: _vm.marketLoading,
                            clearable: "",
                          },
                          on: {
                            change: _vm.onMarketChange,
                            focus: _vm.loadDefaultMarkets,
                          },
                          model: {
                            value: _vm.form.marketId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "marketId", $$v)
                            },
                            expression: "form.marketId",
                          },
                        },
                        _vm._l(_vm.marketOptions, function (market) {
                          return _c(
                            "el-option",
                            {
                              key: market.id,
                              attrs: {
                                label: market.marketName,
                                value: market.id,
                              },
                            },
                            [
                              _c("span", { staticStyle: { float: "left" } }, [
                                _vm._v(_vm._s(market.marketName)),
                              ]),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "right",
                                    color: "#8492a6",
                                    "font-size": "13px",
                                  },
                                },
                                [_vm._v(_vm._s(market.detail))]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "关联商户：", prop: "merId" } },
                    [
                      _vm.selectedMerchantName
                        ? _c("div", { staticClass: "merchant-info" }, [
                            _c("p", { staticClass: "merchant-name" }, [
                              _vm._v(_vm._s(_vm.selectedMerchantName)),
                            ]),
                            _vm.selectedMerchantPhone
                              ? _c("p", { staticClass: "merchant-phone" }, [
                                  _vm._v(_vm._s(_vm.selectedMerchantPhone)),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "activityName" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 活动名称： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "请输入活动的名称，建议简洁明了，便于用户理解",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-input", {
                        staticStyle: { width: "580px" },
                        attrs: {
                          placeholder: "请输入活动名称",
                          maxlength: "50",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.activityName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "activityName", $$v)
                          },
                          expression: "form.activityName",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "registrationTime" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 报名时间： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "设置活动报名的时间范围，用户只能在此时间段内报名参加",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-date-picker", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.form.registrationTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "registrationTime", $$v)
                          },
                          expression: "form.registrationTime",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "activityTime" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 活动时间： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "设置活动实际举办的时间范围，应与报名时间合理衔接",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-date-picker", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          format: "yyyy-MM-dd HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.form.activityTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "activityTime", $$v)
                          },
                          expression: "form.activityTime",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "timeRemark" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 活动时间备注： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "补充说明活动时间安排、签到要求或特殊时间提醒",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-input", {
                        staticStyle: { width: "580px" },
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          maxlength: "200",
                          "show-word-limit": "",
                          placeholder: "请输入活动时间备注",
                        },
                        model: {
                          value: _vm.form.timeRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "timeRemark", $$v)
                          },
                          expression: "form.timeRemark",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "needCount" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 招募摊位数： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "设置本次活动需要招募的摊位数量，用于控制报名人数",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          min: 1,
                          max: 999,
                          placeholder: "请输入招募摊位数",
                        },
                        model: {
                          value: _vm.form.needCount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "needCount", $$v)
                          },
                          expression: "form.needCount",
                        },
                      }),
                      _c("span", { staticClass: "unit-text" }, [_vm._v("个")]),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "1",
                      expression: "currentStep === '1'",
                    },
                  ],
                  staticClass: "step-content",
                },
                [
                  _c(
                    "el-form-item",
                    {
                      style: { "align-items": "flex-start" },
                      attrs: { prop: "activityImg" },
                    },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 活动图片： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "上传活动相关图片，最多可上传9张，建议上传3-5张高质量图片展示活动特色",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "image-upload-container" }, [
                        _c("div", { staticClass: "upload-tips" }, [
                          _c("span", [_vm._v("最多支持上传9张图片")]),
                        ]),
                        _vm.form.activityImg.length > 0
                          ? _c(
                              "div",
                              { staticClass: "image-list" },
                              _vm._l(
                                _vm.form.activityImg,
                                function (img, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "image-item" },
                                    [
                                      _c("el-image", {
                                        staticClass: "image-preview",
                                        attrs: {
                                          src: img,
                                          fit: "cover",
                                          "preview-src-list":
                                            _vm.form.activityImg,
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "image-actions" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "mini",
                                                icon: "el-icon-delete",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeImage(index)
                                                },
                                              },
                                            },
                                            [_vm._v(" 删除 ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm.form.activityImg.length < 9
                          ? _c(
                              "div",
                              {
                                staticClass: "upload-image-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.modalPicTap(true)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "upload-icon" }, [
                                  _c("i", { staticClass: "el-icon-plus" }),
                                ]),
                                _c("div", { staticClass: "upload-text" }, [
                                  _vm._v("上传图片"),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "activityInfo" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 活动详情： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "详细描述活动内容、规则、注意事项等，帮助用户了解活动详情",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("Tinymce", {
                        style: { width: "800px" },
                        attrs: { height: 300 },
                        model: {
                          value: _vm.form.activityInfo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "activityInfo", $$v)
                          },
                          expression: "form.activityInfo",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "bulletScreen" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 详情弹幕配置： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "按条添加活动详情弹幕内容，保存时会自动拼接为逗号分隔字符串",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "bullet-screen-editor" }, [
                        _vm.form.bulletScreen.length
                          ? _c(
                              "div",
                              { staticClass: "bullet-screen-tag-list" },
                              _vm._l(
                                _vm.form.bulletScreen,
                                function (tag, index) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: tag + "-" + index,
                                      staticClass: "bullet-screen-tag",
                                      attrs: { closable: "" },
                                      on: {
                                        close: function ($event) {
                                          return _vm.removeBulletScreenTag(
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(tag) + " ")]
                                  )
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "bullet-screen-input-row" },
                          [
                            _c("el-input", {
                              staticStyle: { width: "320px" },
                              attrs: {
                                placeholder: "输入弹幕内容后回车或点击添加",
                                maxlength: "30",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.addBulletScreenTag($event)
                                },
                              },
                              model: {
                                value: _vm.bulletScreenInput,
                                callback: function ($$v) {
                                  _vm.bulletScreenInput =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "bulletScreenInput",
                              },
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", plain: "" },
                                on: { click: _vm.addBulletScreenTag },
                              },
                              [_vm._v("添加")]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "form-tip" }, [
                          _vm._v("示例：限时优惠、报名从速、摊位有限"),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "agreementStatus" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 协议状态： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "开启协议后，用户报名时需要同意相关协议条款",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.agreementStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "agreementStatus", $$v)
                            },
                            expression: "form.agreementStatus",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("开启"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _vm.form.agreementStatus === 0
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "agreementInfo" } },
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "flex-end",
                                  height: "32px",
                                },
                              },
                              [
                                _vm._v(" 协议详情： "),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content:
                                        "设置用户报名时需要同意的协议内容，如活动规则、免责声明等",
                                      placement: "top",
                                      effect: "dark",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-question",
                                      staticStyle: {
                                        color: "#409EFF",
                                        "font-size": "14px",
                                        "margin-left": "4px",
                                        cursor: "help",
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("Tinymce", {
                            style: { width: "800px" },
                            attrs: { height: 300 },
                            model: {
                              value: _vm.form.agreementInfo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "agreementInfo", $$v)
                              },
                              expression: "form.agreementInfo",
                            },
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "setting" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 活动表单配置： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "选择用户报名时需要填写的表单字段，必选字段不可编辑",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "setting-checkbox-group" },
                        _vm._l(
                          _vm.computedSettingOptions,
                          function (item, key) {
                            return _c(
                              "el-checkbox",
                              {
                                key: key,
                                attrs: { disabled: _vm.isFieldDisabled(key) },
                                on: { change: _vm.updateSettingJson },
                                model: {
                                  value: _vm.computedSettingData[key],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.computedSettingData, key, $$v)
                                  },
                                  expression: "computedSettingData[key]",
                                },
                              },
                              [_vm._v(" " + _vm._s(item) + " ")]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep === "2",
                      expression: "currentStep === '2'",
                    },
                  ],
                  staticClass: "step-content",
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "deposit" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 押金： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "设置用户报名时需要缴纳的押金金额，用于保证参与质量",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          min: 0,
                          max: 999999,
                          placeholder: "请输入押金金额",
                        },
                        model: {
                          value: _vm.form.deposit,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "deposit", $$v)
                          },
                          expression: "form.deposit",
                        },
                      }),
                      _c("span", { staticClass: "unit-text" }, [_vm._v("元")]),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "performanceBond" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 履约保证金： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "设置商户参与活动时需要缴纳的履约保证金金额",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          min: 0,
                          max: 999999,
                          placeholder: "请输入履约保证金",
                        },
                        model: {
                          value: _vm.form.performanceBond,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "performanceBond", $$v)
                          },
                          expression: "form.performanceBond",
                        },
                      }),
                      _c("span", { staticClass: "unit-text" }, [_vm._v("元")]),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "promotionStatus" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 是否开启推广： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "开启后可配置推广协议，并在扩展费用设置中展示公共佣金配置",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-switch", {
                        attrs: {
                          "active-value": 1,
                          "inactive-value": 0,
                          "active-text": "开启",
                          "inactive-text": "关闭",
                        },
                        model: {
                          value: _vm.form.promotionStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "promotionStatus", $$v)
                          },
                          expression: "form.promotionStatus",
                        },
                      }),
                    ],
                    2
                  ),
                  _vm.form.promotionStatus === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { prop: "promotionInfo" } },
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "flex-end",
                                  height: "32px",
                                },
                              },
                              [
                                _vm._v(" 推广协议： "),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content:
                                        "设置推广开启后展示给用户的推广协议内容",
                                      placement: "top",
                                      effect: "dark",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-question",
                                      staticStyle: {
                                        color: "#409EFF",
                                        "font-size": "14px",
                                        "margin-left": "4px",
                                        cursor: "help",
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("Tinymce", {
                            style: { width: "800px" },
                            attrs: { height: 300 },
                            model: {
                              value: _vm.form.promotionInfo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "promotionInfo", $$v)
                              },
                              expression: "form.promotionInfo",
                            },
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "depositRule" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 押金规则： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "详细说明押金的使用规则、退还条件等，让用户清楚了解",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          placeholder: "请输入押金规则说明",
                          maxlength: "200",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.depositRule,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "depositRule", $$v)
                          },
                          expression: "form.depositRule",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { style: { "align-items": "flex-start" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              height: "32px",
                            },
                          },
                          [
                            _vm._v(" 扩展费用设置： "),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "设置额外的费用项目，如摊位费、设备费等",
                                  placement: "top",
                                  effect: "dark",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "14px",
                                    "margin-left": "4px",
                                    cursor: "help",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "fee-list" },
                        [
                          _vm._l(
                            _vm.form.marketActivityExtList,
                            function (fee, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "fee-item",
                                  class: { "fee-item-deleted": fee.isDel },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "fee-actions" },
                                    [
                                      !fee.isDel && fee.negotiable !== 1
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "warning",
                                                size: "small",
                                                icon: "el-icon-edit",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setNegotiable(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(" 费用面议 "),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    content:
                                                      "设置为面议后，则不用在设置费用和抽成",
                                                    placement: "top",
                                                    effect: "dark",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question",
                                                    staticStyle: {
                                                      color: "#FFF",
                                                      "font-size": "14px",
                                                      "margin-left": "4px",
                                                      cursor: "help",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      !fee.isDel && fee.negotiable === 1
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "warning",
                                                size: "small",
                                                icon: "el-icon-refresh-left",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.cancelNegotiable(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 关闭面议 ")]
                                          )
                                        : _vm._e(),
                                      !fee.isDel &&
                                      fee.negotiable !== 1 &&
                                      !fee.hasFee
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small",
                                                icon: "el-icon-plus",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addFeeToItem(index)
                                                },
                                              },
                                            },
                                            [_vm._v(" 添加费用 ")]
                                          )
                                        : _vm._e(),
                                      !fee.isDel &&
                                      fee.negotiable !== 1 &&
                                      fee.hasFee
                                        ? _c(
                                            "el-radio-group",
                                            {
                                              staticClass: "fee-mode-switch",
                                              attrs: { size: "small" },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.onFeeModeChange(
                                                    index
                                                  )
                                                },
                                              },
                                              model: {
                                                value: fee.feeMode,
                                                callback: function ($$v) {
                                                  _vm.$set(fee, "feeMode", $$v)
                                                },
                                                expression: "fee.feeMode",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-radio-button",
                                                { attrs: { label: "normal" } },
                                                [_vm._v("普通费用")]
                                              ),
                                              _c(
                                                "el-radio-button",
                                                { attrs: { label: "free" } },
                                                [_vm._v("免费")]
                                              ),
                                              _c(
                                                "el-radio-button",
                                                { attrs: { label: "subsidy" } },
                                                [_vm._v("补贴")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      !fee.isDel &&
                                      fee.negotiable !== 1 &&
                                      fee.feeMode === "normal" &&
                                      (!fee.hasCommission ||
                                        fee.commissionStatusExt !== 1)
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "success",
                                                size: "small",
                                                icon: "el-icon-plus",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addCommissionToItem(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 添加抽成 ")]
                                          )
                                        : _vm._e(),
                                      fee.isDel
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "success",
                                                size: "small",
                                                icon: "el-icon-refresh-left",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.restoreFee(index)
                                                },
                                              },
                                            },
                                            [_vm._v(" 恢复 ")]
                                          )
                                        : _vm._e(),
                                      !fee.isDel
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "danger",
                                                size: "small",
                                                icon: "el-icon-delete",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeFee(index)
                                                },
                                              },
                                            },
                                            [_vm._v(" 删除 ")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.isFeeConfigActive(fee)
                                    ? _c(
                                        "div",
                                        { staticClass: "fee-name-section" },
                                        [
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 24 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 24 } },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      placeholder: "费用名称",
                                                      disabled: fee.isDel,
                                                    },
                                                    model: {
                                                      value: fee.extName,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          fee,
                                                          "extName",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "fee.extName",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  fee.negotiable === 1 && !fee.isDel
                                    ? _c(
                                        "div",
                                        { staticClass: "negotiable-display" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "negotiable-text" },
                                            [_vm._v("面议")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  fee.hasFee && fee.negotiable !== 1
                                    ? _c(
                                        "div",
                                        { staticClass: "fee-section" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "section-title" },
                                            [_vm._v("费用设置")]
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 15 } },
                                            [
                                              fee.feeMode === "normal"
                                                ? _c(
                                                    "el-col",
                                                    { attrs: { span: 4 } },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            placeholder:
                                                              "费用类型",
                                                            disabled: fee.isDel,
                                                          },
                                                          model: {
                                                            value: fee.extType,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                fee,
                                                                "extType",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "fee.extType",
                                                          },
                                                        },
                                                        [
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: "摊位费用",
                                                              value: 0,
                                                            },
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: "补充费用",
                                                              value: 1,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              fee.feeMode === "free"
                                                ? _c(
                                                    "el-col",
                                                    { attrs: { span: 8 } },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "free-display",
                                                        },
                                                        [_vm._v("免费活动")]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              fee.feeMode !== "free" &&
                                              !fee.isRangeFee
                                                ? _c(
                                                    "el-col",
                                                    { attrs: { span: 8 } },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "align-items":
                                                              "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticStyle: {
                                                                width:
                                                                  "calc(100% - 30px)",
                                                              },
                                                              attrs: {
                                                                min: 1,
                                                                max: 999999,
                                                                placeholder:
                                                                  fee.feeMode ===
                                                                  "subsidy"
                                                                    ? "补贴金额"
                                                                    : "费用金额",
                                                                disabled:
                                                                  fee.isDel,
                                                              },
                                                              model: {
                                                                value:
                                                                  fee.extFee,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      fee,
                                                                      "extFee",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "fee.extFee",
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "unit-text",
                                                              staticStyle: {
                                                                "margin-left":
                                                                  "8px",
                                                              },
                                                            },
                                                            [_vm._v("元")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              fee.feeMode === "normal" &&
                                              fee.isRangeFee
                                                ? _c(
                                                    "el-col",
                                                    { attrs: { span: 8 } },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "align-items":
                                                              "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticStyle: {
                                                                width:
                                                                  "calc(50% - 30px)",
                                                              },
                                                              attrs: {
                                                                min: 1,
                                                                max: 999999,
                                                                placeholder:
                                                                  "最低费用",
                                                                disabled:
                                                                  fee.isDel,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onExtFeeChange(
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  fee.extFee,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      fee,
                                                                      "extFee",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "fee.extFee",
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "unit-text",
                                                              staticStyle: {
                                                                margin: "0 8px",
                                                              },
                                                            },
                                                            [_vm._v("元")]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                margin: "0 8px",
                                                                color:
                                                                  "#606266",
                                                              },
                                                            },
                                                            [_vm._v("—")]
                                                          ),
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticStyle: {
                                                                width:
                                                                  "calc(50% - 30px)",
                                                              },
                                                              attrs: {
                                                                min:
                                                                  (fee.extFee ||
                                                                    0) + 1,
                                                                max: 999999,
                                                                placeholder:
                                                                  "最高费用",
                                                                disabled:
                                                                  fee.isDel,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onExtFeeMaxChange(
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  fee.extFeeMax,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      fee,
                                                                      "extFeeMax",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "fee.extFeeMax",
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "unit-text",
                                                              staticStyle: {
                                                                "margin-left":
                                                                  "8px",
                                                              },
                                                            },
                                                            [_vm._v("元")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              fee.feeMode !== "free"
                                                ? _c(
                                                    "el-col",
                                                    { attrs: { span: 4 } },
                                                    [
                                                      _c("el-input-number", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          min: 1,
                                                          max: 999,
                                                          placeholder: "单位值",
                                                          disabled: fee.isDel,
                                                        },
                                                        model: {
                                                          value: fee.unitValue,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              fee,
                                                              "unitValue",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "fee.unitValue",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              fee.feeMode !== "free"
                                                ? _c(
                                                    "el-col",
                                                    { attrs: { span: 8 } },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "align-items":
                                                              "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-select",
                                                            {
                                                              staticStyle: {
                                                                flex: "1",
                                                                "min-width":
                                                                  "0",
                                                              },
                                                              attrs: {
                                                                placeholder:
                                                                  "计量单位",
                                                                disabled:
                                                                  fee.isDel,
                                                              },
                                                              model: {
                                                                value: fee.unit,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      fee,
                                                                      "unit",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "fee.unit",
                                                              },
                                                            },
                                                            [
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "天",
                                                                  value: "天",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "周",
                                                                  value: "周",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "月",
                                                                  value: "月",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "年",
                                                                  value: "年",
                                                                },
                                                              }),
                                                              _c("el-option", {
                                                                attrs: {
                                                                  label: "小时",
                                                                  value: "小时",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                          !fee.isDel
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "8px",
                                                                  },
                                                                  attrs: {
                                                                    type: "danger",
                                                                    size: "mini",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeFeeFromItem(
                                                                          index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " 移除 "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            {
                                              staticStyle: {
                                                "margin-top": "10px",
                                              },
                                              attrs: { gutter: 15 },
                                            },
                                            [
                                              fee.feeMode === "normal"
                                                ? _c(
                                                    "el-col",
                                                    { attrs: { span: 8 } },
                                                    [
                                                      _c(
                                                        "el-checkbox",
                                                        {
                                                          attrs: {
                                                            disabled: fee.isDel,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.onRangeFeeChange(
                                                                index
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              fee.isRangeFee,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                fee,
                                                                "isRangeFee",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "fee.isRangeFee",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " 设置区间费用 "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  fee.feeMode === "normal" &&
                                  fee.hasCommission &&
                                  fee.commissionStatusExt === 1 &&
                                  fee.negotiable !== 1
                                    ? _c(
                                        "div",
                                        { staticClass: "commission-section" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "section-title" },
                                            [_vm._v("抽成设置")]
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 15 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 16 } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "align-items": "center",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input-number", {
                                                        staticStyle: {
                                                          flex: "0 0 220px",
                                                        },
                                                        attrs: {
                                                          min: 0,
                                                          max: 100,
                                                          placeholder:
                                                            "抽成比例",
                                                          disabled: fee.isDel,
                                                        },
                                                        model: {
                                                          value:
                                                            fee.commissionExt,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              fee,
                                                              "commissionExt",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "fee.commissionExt",
                                                        },
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "unit-text",
                                                          staticStyle: {
                                                            "margin-left":
                                                              "8px",
                                                          },
                                                        },
                                                        [_vm._v("%")]
                                                      ),
                                                      !fee.isDel
                                                        ? _c(
                                                            "el-button",
                                                            {
                                                              staticStyle: {
                                                                "margin-left":
                                                                  "8px",
                                                              },
                                                              attrs: {
                                                                type: "danger",
                                                                size: "mini",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeCommissionFromItem(
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v(" 移除 ")]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.shouldShowPromotionConfig(fee)
                                    ? _c(
                                        "div",
                                        { staticClass: "commission-section" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "section-title" },
                                            [_vm._v("佣金配置")]
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 15 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 16 } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "align-items": "center",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input-number", {
                                                        staticStyle: {
                                                          flex: "0 0 220px",
                                                        },
                                                        attrs: {
                                                          min: 0,
                                                          max: 999999,
                                                          step: 0.01,
                                                          precision: 2,
                                                          placeholder:
                                                            "佣金金额",
                                                          disabled: fee.isDel,
                                                        },
                                                        model: {
                                                          value: fee.promotion,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              fee,
                                                              "promotion",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "fee.promotion",
                                                        },
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "unit-text",
                                                          staticStyle: {
                                                            "margin-left":
                                                              "8px",
                                                          },
                                                        },
                                                        [_vm._v("元")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.isFeeConfigActive(fee)
                                    ? _c(
                                        "div",
                                        { staticClass: "fee-remark-section" },
                                        [
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 24 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 24 } },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: {
                                                      type: "textarea",
                                                      rows: 2,
                                                      placeholder:
                                                        "费用备注（选填）",
                                                      disabled: fee.isDel,
                                                      maxlength: "200",
                                                      "show-word-limit": "",
                                                    },
                                                    model: {
                                                      value: fee.feeRemark,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          fee,
                                                          "feeRemark",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fee.feeRemark",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.shouldShowFeeExample(fee)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "fee-example",
                                          class: {
                                            "fee-example-deleted": fee.isDel,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "example-label" },
                                            [_vm._v("费用示例：")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "example-text" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.getFeeExample(fee))
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  fee.isDel
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "deleted-label-overlay",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "deleted-label" },
                                            [_vm._v("（已删除）")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-plus",
                              },
                              on: { click: _vm.addFee },
                            },
                            [_vm._v(" 添加费用模板 ")]
                          ),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "step-actions" },
                [
                  _c("el-button", { on: { click: _vm.goBack } }, [
                    _vm._v("取消"),
                  ]),
                  _vm.currentStep !== "0"
                    ? _c("el-button", { on: { click: _vm.prevStep } }, [
                        _vm._v("上一步"),
                      ])
                    : _vm._e(),
                  _vm.currentStep !== "2"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.stepLoading },
                          on: {
                            click: function ($event) {
                              _vm.saveStep(parseInt(_vm.currentStep))
                            },
                          },
                        },
                        [_vm._v(" 保存并下一步 ")]
                      )
                    : _vm._e(),
                  _vm.currentStep === "2"
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.submitLoading,
                            disabled: _vm.submitLoading,
                          },
                          on: { click: _vm.submitForm },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.form.id ? "完成更新" : "完成创建") +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }